export enum COMMUNICATION_UNIT_PACKAGE_VISIBILITY {
  PUBLIC = 'PUBLIC',
  INTERNAL = 'INTERNAL',
}
